require('angular')
    .module('oly.common')
    .directive('olyAnalyticsOnClick', require('./analytics/analytics-on-click.directive').analyticsOnClickDirectiveDefinition)
    .run(['$window', 'BootstrapService', require('./analytics/analytics-config')])
    .service('GtmService', ['$window', '$injector', '$timeout', require('./gtm/gtm.service')])
    .service('DtmService', ['$window', '$injector', '$timeout', require('./dtm/dtm.service')])
    .service('AnalyticsService', ['GtmService', 'DtmService', 'SettingsService', '$log', require('./analytics/analytics.service')])
    .directive('analyticsInput', ['AnalyticsService', require('./analytics/analytics-input.directive')])
    .directive('wowAnalyticsFormErrors', ['AnalyticsService', require('./analytics/analytics-form-errors.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/analytics/index.js